import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import abo1 from "../image/Image _ Page/Service_page/Cloud-Service_slider.jpg";
import abo2 from "../image/Image _ Page/Service_page/Datacentre & Virtualization_slider.jpeg";
import abo3 from "../image/Image _ Page/Service_page/Network & Security Service_slider.jpeg";
import abo4 from "../image/Image _ Page/Service_page/Collaboration And IOT_slider.jpeg";
import abo5 from "../image/Image _ Page/Service_page/Automation, AI & Analytics_slider.jpeg";
import abo6 from "../image/Image _ Page/Service_page/Professional & Managed Services_slider.jpeg";
import ".././Components/style/serviceslide.css"

const data = [
  { 
    image: abo1, 
    title: "Cloud-Service",
    // header: "Optimized CloudOps Solutions",
    description: "Maximize your cloud investments with our CloudOps services. We ensure efficient management, scalability, and cost-effectiveness for your cloud infrastructure."
  },
  { 
    image: abo2, 
    title: "Datacentre & Virtualization",
    // header: "Data Centre & Virtualization Solutions",
    description: "Modernize your infrastructure with our data centre and virtualization expertise. We design, implement, and manage scalable, high-performance environments tailored to your business needs."
  },
  { 
    image: abo3, 
    title: "Network & Security Service",
    // header: "Comprehensive Security Solutions",
    description: "Protect your business from evolving cyber threats. Our security solutions encompass assessments, threat detection, and mitigation strategies to safeguard your data."
  },
  { 
    image: abo4, 
    title: "Collaboration And IOT",
    // header: "Network, IoT & Collaboration Solutions",
    description: "Connect your workforce and devices seamlessly. We build secure, reliable networks, integrate IoT solutions, and deploy collaboration tools for enhanced productivity."
  },
  { 
    image: abo5, 
    title: "Automation, AI & Analytics",
    // header: "Automation & Analytics Solutions",
    description: "Drive efficiency and gain valuable insights. We automate processes and implement analytics solutions to empower data-driven decision-making."
  },
  { 
    image: abo6, 
    title: "Professional & Managed Services",
    // header: "Professional & Managed IT Services",
    description: "Focus on your core business while we manage your IT. Our expert team provides proactive support, maintenance, and 24/7 monitoring."
  },
];



const ServiceSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    cssEase: "ease-in-out",
    responsive: [
      {
        breakpoint: 1024, // Tablet view
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // Mobile view
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // Small mobile view
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    // Inline style forces a transparent background here, overriding whatever
    // background-color serviceslide.css sets on .service-section — so this
    // section blends into whatever the page's actual background is.
    <div className="service-section" style={{ background: "transparent" }}>
      <div className="service-container">
        <Slider {...settings}>
          {data.map((item, index) => (
            <div
              key={index}
              className="service-card"
              style={{ borderRadius: "16px", overflow: "hidden" }}
            >
              <div className="service-image-container">
                <img
                  src={item.image}
                  alt={item.title}
                  className="service-image"
                />
              </div>
              <div className="service-text">
                <h3 className="service-title">{item.title}</h3>
                <h4 className="service-header">{item.header}</h4>
                <p className="service-description">{item.description}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ServiceSlider;